/* eslint-disable */
import { Chip, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import FolderIcon from '@material-ui/icons/Folder';
import cn from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Autocomplete from '../Autocomplete/Autocomplete.component';
import ChipSelectorPropTypes from './ChipSelector.component.props';
import chipSelectorStyles from './ChipSelector.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * ChipSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const ChipSelector = ({ classes, chips, onSelect, errorText, fullWidthItems, placeholder = `Please enter` }) => {
  const [defaultValue, setDefaultValue] = useState(``);
  const [filterText, setFilterText] = useState(``);
  const [autocompleteError, setAutocompleteError] = useState(null);

  return (
    <div>
      <Autocomplete
        menuItemClasses={classes.menuItem}
        onClear={() => {
          setFilterText(``);
          setAutocompleteError(null);
        }}
        onBlur={(typedText) => {
          if (!chips) {
            return;
          }
          const foundService = chips.find((el) => typedText === el.name);
          if (typedText && chips && !foundService) {
            setAutocompleteError(errorText);
          } else {
            setAutocompleteError(null);
          }
        }}
        defaultValue={defaultValue}
        onSelect={(el) => {
          onSelect(el.name);
          setDefaultValue(el.name);
        }}
        onType={(e) => {
          setFilterText(e.target.value);
        }}
        error={autocompleteError}
        options={
          !chips
            ? []
            : chips
                .map((el, i) => {
                  return {
                    name: el.name,
                    component: (
                      <Tooltip title={el.name}>
                        <Chip
                          data-mf-replace-inner={MFSDR}
                          icon={<FolderIcon className={classes.colorZambezi600} />}
                          label={el.name}
                          variant="outlined"
                          classes={{
                            root: fullWidthItems ? cn(classes.chipRoot, classes.fullWidthItems) : classes.chipRoot,
                            label: classes.chipLabel,
                          }}
                        />
                      </Tooltip>
                    ),
                  };
                })
                .filter((el) => el.name.toLowerCase().includes(filterText.toLowerCase()))
        }
        placeholder={placeholder}
        fullWidth
        // validateFor={/^[a-zA-Z0-9\s\-]*$/} // put regex here to validate keyboard input  if required
        isLoading={false}
      />
    </div>
  );
};

ChipSelector.propTypes = ChipSelectorPropTypes;

export default compose(
  withStyles(themeCreateInjectableStyles(chipSelectorStyles), { withTheme: true }),
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(ChipSelector);
